/*
  "Buy it now" skips the cart, so a stitching add-on can never ride along with it.
  The options app blocks the button in that state but gives no feedback, which reads
  as a dead button. This hides it instead, with a line saying why, and brings it
  straight back when the services are cleared.

  Detection works for both the Aris/APO app and the native block, because both keep
  the same hidden line-item property in the product form.
*/
(function () {
  'use strict';
  if (window.__mtlExpressGuard) return;
  window.__mtlExpressGuard = true;

  var PROP = 'properties[Do you want to stitch]';
  var NOTE = 'mtl-express-note';

  function stitchingChosen(scope) {
    var field = scope.querySelector('[name="' + PROP + '"]');
    if (field && !field.disabled && String(field.value || '').trim()) return true;
    // Native block, before the hidden field has synced.
    return !!scope.querySelector('.mtl-stitch__cb:checked');
  }

  function noteFor(wrap) {
    var note = wrap.parentNode && wrap.parentNode.querySelector('.' + NOTE);
    if (note) return note;
    note = document.createElement('p');
    note.className = NOTE;
    note.setAttribute('role', 'status');
    note.textContent = 'Express checkout is not available with stitching — use Add to cart.';
    note.style.cssText =
      'margin:0.8rem 0 0;font-size:1.2rem;line-height:1.4;opacity:0.7;text-align:center;';
    wrap.parentNode.insertBefore(note, wrap.nextSibling);
    return note;
  }

  function apply(scope) {
    var wrap = scope.querySelector('.shopify-payment-button');
    if (!wrap || !wrap.parentNode) return;
    var hide = stitchingChosen(scope);
    if (wrap.hidden !== hide) wrap.hidden = hide;
    // The theme styles the ATC as secondary while express checkout is shown;
    // make it the primary button again once express is hidden.
    var atc = scope.querySelector('product-form button[name="add"]');
    if (atc) {
      atc.classList.toggle('button--primary', hide);
      atc.classList.toggle('button--secondary', !hide);
    }
    noteFor(wrap).hidden = !hide;
  }

  // Only real product forms. Falling back to the whole document made pages without one
  // (home, collections, blog) re-run this on every class change: 0.2-0.5 s of phone CPU.
  function scopes() {
    return Array.prototype.slice.call(document.querySelectorAll('product-info, .product'));
  }

  function refresh() { scopes().forEach(apply); }

  document.addEventListener('change', function (e) {
    if (!e.target.name && !e.target.classList) return;
    if (e.target.name === 'Do you want to stitch' ||
        e.target.name === PROP ||
        (e.target.classList && e.target.classList.contains('mtl-stitch__cb'))) {
      // Let the app's own handlers write the hidden field first.
      setTimeout(refresh, 0);
    }
  }, true);

  // The app writes the hidden field without firing a change event we can see,
  // so watch the form for attribute and child changes as well.
  function watch() {
    scopes().forEach(function (scope) {
      if (scope.hasAttribute('data-mtl-guard')) return;
      scope.setAttribute('data-mtl-guard', '');
      try {
        new MutationObserver(function () { refresh(); }).observe(scope, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['value', 'disabled', 'checked', 'class']
        });
      } catch (e) { /* observation is a nicety; the change listener still works */ }
    });
    refresh();
  }

  // Forms can arrive after load (quick-add modal). Watch for new elements only, then give
  // each new form the full observer above; attribute changes elsewhere are ignored.
  function watchForLateForms() {
    try {
      new MutationObserver(function () {
        if (document.querySelector('product-info:not([data-mtl-guard]), .product:not([data-mtl-guard])')) watch();
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* the change listener still covers user clicks */ }
  }

  function start() { watch(); watchForLateForms(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(watch, 1500); // app markup mounts late
})();
